import { Tooltip } from '@squareup/dex-ui';
import React, { FC, PropsWithChildren } from 'react';

interface MdxTooltipProps {
  // Fern's source uses `tip="…"` as the prop name; dex-ui's Tooltip
  // calls it `text`. Translate so authors keep the existing prop name.
  tip: string;
}

// `<Tooltip tip="…">visible text</Tooltip>` — wraps an inline span of
// text with a hover/focus tooltip. Fern uses this both inline in pages
// and inside snippet files (e.g. `tooltip-payment-token.mdx`); the
// snippet form gets recursively inlined by `<Markdown src=…>`, so the
// adapter has to be registered on every render path that resolves
// snippets — which is what the precompile step does.
const MdxTooltip: FC<PropsWithChildren<MdxTooltipProps>> = ({
  children,
  tip,
}) => {
  return <Tooltip text={tip}>{children}</Tooltip>;
};

MdxTooltip.displayName = 'MdxTooltip';

export { MdxTooltip };
